import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSession, setClubToken, CLUB_BASE } from "./clubApi";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const done = useRef(false);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate(`${CLUB_BASE}/team`, { replace: true }); return; }
    exchangeSession(decodeURIComponent(m[1]))
      .then((res) => {
        if (res?.session_token) setClubToken(res.session_token);
        window.history.replaceState({}, "", `${CLUB_BASE}/team`);
        navigate(`${CLUB_BASE}/team`, { replace: true, state: { user: res.user } });
      })
      .catch((e) => setErr(e?.response?.data?.detail || "Accesso non riuscito"));
  }, [navigate]);
  return (
    <div className="min-h-screen bg-[#0E0E10] flex items-center justify-center text-[#9A948A] text-sm" data-testid="club-auth-callback">
      {err ? <span className="text-[#ff9a9e]">{err}</span> : <div className="w-6 h-6 border-2 border-[#E5B13A] border-t-transparent rounded-full animate-spin" />}
    </div>
  );
}
